import * as React from 'react'
import PlacesAutocomplete from 'react-places-autocomplete'
import { TextField } from '@material-ui/core'
import InputAdornment from '@material-ui/core/InputAdornment'
import Search from '@material-ui/icons/Search'
import Close from '@material-ui/icons/Close'
import images from '../images'

import '../styles/PickupLocation.scss'
import { StringResources } from '../localization/StringResources'
import { Strings } from '../localization'

interface LocationSearchInputState {
}

export interface LocationSearchInputProps {
	address?: string
	apartmentNumber?: string
	isApartmentNumberActive?: boolean
	onAddressChange?: (address: string, complete: boolean) => void
	onApartmentNumberChanged?: (apartmentNumber: string) => void
	onApartmentEnabled?: (isEnabled: boolean) => void
	setCurrentLocation?: () => void
}

interface InputSuggestionInterface {
	getInputProps: any,
	suggestions: any,
	getSuggestionItemProps: any
}

export default class LocationSearch extends React.Component<LocationSearchInputProps, LocationSearchInputState> {
	constructor(props: LocationSearchInputProps) {
		super(props)
		this.state = {}
	}

	onAutocompleteChanged = (e: string) => {
		if (this.props.onAddressChange) {
			this.props.onAddressChange(e, false)
		}
	}

	onAutocompleteSelected = (e: string) => {
		if (this.props.onAddressChange) {
			this.props.onAddressChange(e, true)
		}
	}

	onApartmentNumberChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (this.props.onApartmentNumberChanged) {
			this.props.onApartmentNumberChanged(e.target.value)
		}
	}

	onIsApartmentChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (this.props.onApartmentEnabled) {
			this.props.onApartmentEnabled(e.target.checked)
		}
	}

	onOptionClick = (value: string) => {
		return (e: React.MouseEvent<HTMLElement>) => {
			if (this.props.onAddressChange) {
				this.props.onAddressChange(value, true)
			}
		}
	}

	onSetCurrentLocation = () => {
		if (this.props.setCurrentLocation) {
			this.props.setCurrentLocation()
		}
	}

	onClear = () => {
		if (this.props.onAddressChange) {
			this.props.onAddressChange('', false)
		}
		if (this.props.onApartmentNumberChanged) {
			this.props.onApartmentNumberChanged('')
		}
		if (this.props.onApartmentEnabled) {
			this.props.onApartmentEnabled(false)
		}
	}

	render() {
		return (
			<div className="places-autocomplete">
				<PlacesAutocomplete
					value={this.props.address ? this.props.address : ''}
					onChange={this.onAutocompleteChanged}
					onSelect={this.onAutocompleteSelected}
				>
					{({ getInputProps, suggestions, getSuggestionItemProps }: InputSuggestionInterface) => (
						<div className="search-container">
							<TextField
								name="text-field"
								label={StringResources.getString(Strings.Components.LocationSearch.Inputs.JobLocation.label)}
								placeholder={`Search`}
								{...getInputProps({
									className: 'search-input'
								})}
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<Search />
										</InputAdornment>
									),
									endAdornment: (
										<InputAdornment position="end">
											<Close
												onClick={this.onClear}
												className="clear-button"
											/>
										</InputAdornment>
									)
								}}
							/>
							<div className="apartment">
								<div className="squaredTwo">
									<input type="checkbox" id="cbx" className="inp-cbx" checked={this.props.isApartmentNumberActive} onChange={this.onIsApartmentChange} />
									<label htmlFor="cbx" className="cbx">
										<span>
											<svg width="12px" height="10px" viewBox="0 0 12 10" style={{ display: !this.props.isApartmentNumberActive ? 'none' : '' }} >
												<polyline points="1.5 6 4.5 9 10.5 1" />
											</svg>
										</span>
										<span>{StringResources.getString(Strings.Components.LocationSearch.Checkboxes.Apartment.label)}</span>
									</label>
								</div>
								{
									this.props.isApartmentNumberActive ?
										<input
											value={this.props.apartmentNumber ? this.props.apartmentNumber : ''}
											type="text"
											maxLength={5}
											className="apartment-number"
											disabled={!this.props.isApartmentNumberActive}
											onChange={this.onApartmentNumberChanged}
										/> : null
								}
							</div>
							<div className="autocomplete-dropdown-container">
								{suggestions.map((suggestion: any) => {
									const className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item'
									return (
										// tslint:disable-next-line:jsx-key
										<div {...getSuggestionItemProps(suggestion, { className })}>
											<span onClick={this.onOptionClick(suggestion.description)}>
												{suggestion.description}
											</span>
										</div>
									)
								})}
							</div>
							<button type="button" className="current-location-button" onClick={this.onSetCurrentLocation}>
								<img src={images.currentLocation} />
							</button>
						</div>
					)}
				</PlacesAutocomplete>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/LocationSearch.tsx